import React, { Fragment } from 'react';
import { withNamespaces } from 'react-i18next';
import Money from 'components/formatters/money-formatter';
import { inject, observer } from 'mobx-react';
import LoadingIntermediate from 'components/indicators/loading-intermdiate';

const ActualWidget = ({ t, store }) => {
    const { loading, actual, budgeted, remaining } = store.budget;

    return (
        <div className={`card no-border widget-loader-bar ${remaining < 0 ? 'bg-danger' : 'bg-success'}`}>
            <div className="container-xs-height full-height">
                <div className="row-xs-height">
                    <div className="col-xs-height col-top">
                        <div className="card-header  top-left top-right">
                            <div className="card-title">
                            <span className="font-montserrat fs-11 all-caps text-white">
                                {t('BUDGET.ACTUAL.NAME')}
                            </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row-xs-height">
                    <div className="col-xs-height col-top">
                        <div className="p-l-20 p-t-50 p-b-20 p-r-20">
                            { loading ? (
                                <LoadingIntermediate />
                            ) : (
                                <Fragment>
                                    <h2 className="no-margin p-b-10 text-white">
                                        <Money value={actual} />
                                    </h2>
                                    { remaining >= 0 ? budgeted > 0 && (
                                        <Fragment>
                                            <span className="small hint-text pull-left text-white">
                                                {Math.round(actual / budgeted * 100)}% {t('BUDGET.ACTUAL.SPENT')}
                                            </span>
                                        </Fragment>
                                    ) : (
                                        <Fragment>
                                            <span className="small hint-text pull-left text-white">
                                                {t('BUDGET.ACTUAL.OVER_BUDGET')}:
                                            </span>
                                            <span className="pull-right small text-white">
                                                <Money value={-remaining} />
                                            </span>
                                        </Fragment>
                                    )}
                                </Fragment>
                            )}
                        </div>
                    </div>
                </div>

                {/*
            <div className="row-xs-height">
                <div className="col-xs-height col-bottom">
                    <div className="progress progress-small m-b-0">
                        <div className="progress-bar progress-bar-primary" style={{width:'71%'}} />
                    </div>
                </div>
            </div>
            */}
            </div>
        </div>
    );
};

export default withNamespaces()(
    inject('store')(
        observer(ActualWidget)
    )
);


// WEBPACK FOOTER //
// ./src/modules/budget/components/actual-widget.js